// 요소 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================
// 요소 폭
const getWidth = (aRef) => {
  if (aRef && aRef.current) {
    return aRef.current.offsetWidth;
  } else {
    return 0;
  }
};

// 요소 높이
const getHeight = (aRef) => {
  if (aRef && aRef.current) {
    return aRef.current.offsetHeight;
  } else {
    return 0;
  }
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  getWidth,
  getHeight,
};
